/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import OperationsMenuMobile from './operationsMenuMobile/OperationsMenuMobile';
import LinkedAccountsMenu from './userSwitchMenuMobile/LinkedAccountsMenuMobile';
import LanguagesMenu from './languagesMenuMobile/LanguagesMenuMobile';
import ConfirmConnectToMasterMenu from './confirmConnectToMasterMenuMobile/ConfirmConnectToMasterMenuMobile';
import ConfirmDisconnectFromMasterMenu from './confirmDisconnectFromMasterMenu/ConfirmDisconnectFromMasterMenuMobile';

import { Investor } from '../../types/investorTypes';
import { PAMMState } from '../../redux/reducers/rootReducer';
import {
  setConnectToMasterConfirmationStatus,
  setDisconnectFromMasterConfirmationStatus,
  setLanguagesMenuStatus,
  setLinkedAccountsMenuStatus,
  setMasterFundsMenuStatus,
  setOpsMenuStatus
} from '../../redux/actions/setMobileMenusStatus';
import MobileMenuShadow from './MobileMenuShadow';
import LocalStorageUtils from '../../utils/local-storage';
import { useUser } from '../../utils/useUser';
import { fetchLanguageJSONAsync } from '../../redux/actions/shared/fetchConfig';
import MasterFundsMenu from './userSwitchMenuMobile/MasterFundsMenuMobile';
import { AccountType } from '../../types/authTypes';

const MobileMenu: React.FC = (): JSX.Element => {
  const dispatch: any = useDispatch();
  const user = useUser();

  const investors: Array<Investor> = useSelector((state: PAMMState) => state.investorsReducer.investors);
  const currentLang: string | null = LocalStorageUtils.getValueFromLocalStorage('lang');
  const defaultLanguage: string = useSelector((state: PAMMState) => state.configReducer.defaultLanguage);

  const showOpsMenu = useSelector((state: PAMMState) => state.mobileMenusStatusReducer.showOpsMenu);
  const showLinkedAccountsMenu = useSelector((state: PAMMState) => state.mobileMenusStatusReducer.showlinkedAccountsMenu);
  const showMasterFundsMenu = useSelector((state: PAMMState) => state.mobileMenusStatusReducer.showMasterFundsMenu);
  const showLanguagesMenu = useSelector((state: PAMMState) => state.mobileMenusStatusReducer.showLanguagesMenu);
  const showConfirmConnectToMasterMenu = useSelector(
    (state: PAMMState) => state.mobileMenusStatusReducer.showConnectToMasterConfirmation
  );
  const showConfirmDisconnectFromMasterMenu = useSelector(
    (state: PAMMState) => state.mobileMenusStatusReducer.showDisconnectFromMasterConfirmation
  );

  let touches: any = [];
  const handleSwipe = (event: any) => {
    touches.push(event.pageY);
  };

  const showShadow =
    showOpsMenu ||
    showLinkedAccountsMenu ||
    showMasterFundsMenu ||
    showLanguagesMenu ||
    showConfirmConnectToMasterMenu ||
    showConfirmDisconnectFromMasterMenu;

  const handleCancel = (menu: string): void => {
    if (touches[0] < touches[touches.length - 1]) {
      if (menu === 'operationsMenu') {
        dispatch(setOpsMenuStatus(false));
      } else if (menu === 'linkedAccountsMenu') {
        dispatch(setLinkedAccountsMenuStatus(false));
      } else if (menu === 'masterFundsMenu') {
        dispatch(setMasterFundsMenuStatus(false));
      } else if (menu === 'languagesMenu') {
        dispatch(setLanguagesMenuStatus(false));
      } else if (menu === 'confirmConnectToMasterMenu') {
        dispatch(setConnectToMasterConfirmationStatus(false));
      } else if (menu === 'confirmDisconnectFromMasterMenu') {
        dispatch(setDisconnectFromMasterConfirmationStatus(false));
      }
    }

    touches = [];
  };

  const handleCancelSingleTouch = (): void => {
    if (showOpsMenu) {
      dispatch(setOpsMenuStatus(false));
    } else if (showLinkedAccountsMenu) {
      dispatch(setLinkedAccountsMenuStatus(false));
    } else if (showMasterFundsMenu) {
      dispatch(setMasterFundsMenuStatus(false));
    } else if (showLanguagesMenu) {
      dispatch(setLanguagesMenuStatus(false));
    } else if (showConfirmConnectToMasterMenu) {
      dispatch(setConnectToMasterConfirmationStatus(false));
    } else if (showConfirmDisconnectFromMasterMenu) {
      dispatch(setDisconnectFromMasterConfirmationStatus(false));
    }
  };

  const onLangChange = (langKey: string): void => {
    LocalStorageUtils.putValueToLocalStorage('lang', langKey);
    dispatch(fetchLanguageJSONAsync(langKey));

    dispatch(setLanguagesMenuStatus(false));
  };
  return (
    <>
      <OperationsMenuMobile onSwipe={handleSwipe} onCancel={handleCancel} currentLang={currentLang || defaultLanguage} />
      {investors?.length > 0 && user?.AccountType !== AccountType.Admin ? (
        <LinkedAccountsMenu onSwipe={handleSwipe} onCancel={handleCancel} />
      ) : null}
      <MasterFundsMenu onSwipe={handleSwipe} onCancel={handleCancel} />
      <LanguagesMenu onSwipe={handleSwipe} onCancel={handleCancel} onLangChange={onLangChange} />
      <ConfirmConnectToMasterMenu onSwipe={handleSwipe} onCancel={handleCancel} />
      <ConfirmDisconnectFromMasterMenu onSwipe={handleSwipe} onCancel={handleCancel} />
      <MobileMenuShadow handleClose={handleCancelSingleTouch} show={showShadow} />
    </>
  );
};

export default MobileMenu;
